import { Chip, Divider, Tooltip, Typography } from '@material-ui/core';
import useResponsive from './hooks/useResponsive';
import { useQualityTranslation } from './hooks/useQualityTranslation';
import { qualityClassColor } from './manageColors';

export const viewPositionText = (projection, t) => {
  if (projection === 'rcc') {
    return t('Dashboard.rcc').toUpperCase();
  }
  if (projection === 'lcc') {
    return t('Dashboard.lcc').toUpperCase();
  }
  if (projection === 'rmlo') {
    return t('Dashboard.rmlo').toUpperCase();
  }
  if (projection === 'lmlo') {
    return t('Dashboard.lmlo').toUpperCase();
  }
};

export const qualityEvaluationChip = (
  view_position,
  qualityResult,
  qualityExplanation,
  qualityPoints,
  zoomedProjection,
  onQualityChipClick,
  qualityInfoMode,
  qualityInRevison,
  theme,
  t
) => {
  const quality = useQualityTranslation(qualityResult, t);
  let qualityCapitalized = t('ResultView.missing_evaluated');
  const hasQualityPoints = Number.isFinite(qualityPoints);

  if (!!qualityResult && qualityResult.length > 0)
    qualityCapitalized = quality[0].toUpperCase() + quality.slice(1, quality.length);

  return (
    <Tooltip
      arrow
      title={
        <div>
          <Typography
            style={{
              letterSpacing: '0.1rem',
              fontSize: theme.fonts.responsiveMedium,
              fontWeight: 'bold',
            }}>
            {`${viewPositionText(view_position, t)} ${t('ResultView.quality')}: ${
              t(`Quality.${qualityCapitalized}`, { defaultValue: qualityCapitalized }) ??
              t('ResultView.not_evaluated')
            }`}
          </Typography>
          {hasQualityPoints && !qualityInRevison && (
            <Typography
              style={{
                letterSpacing: '0.06rem',
                fontSize: theme.fonts.responsiveMedium,
                fontWeight: 600,
                marginTop: '4px',
              }}>
              {`${qualityPoints} ${t('Quality.points_label', { defaultValue: t('Dashboard.points') })}`}
            </Typography>
          )}
          {qualityExplanation && qualityExplanation.length > 0 && !qualityInRevison && (
            <>
              <Divider style={{ margin: '3% 0' }} />
              {qualityExplanation.map((explanation, index) => (
                <Typography
                  key={index}
                  style={{
                    letterSpacing: '0.1rem',
                    fontSize: theme.fonts.responsiveMedium,
                  }}>
                  {Array.isArray(explanation)
                    ? `- ${explanation.map((exp) => t(`Quality.${exp}`, { defaultValue: exp })).join(' ')}`
                    : `- ${t(`Quality.${explanation}`, { defaultValue: explanation })}`}
                </Typography>
              ))}
            </>
          )}
        </div>
      }>
      <Chip
        variant='default'
        onClick={() => {
          if (qualityInRevison) onQualityChipClick();
        }}
        label={
          <Typography
            style={{
              fontSize: '1.2vh',
              letterSpacing: '0.1rem',
              lineHeight: 'normal',
            }}>
            {t(`Quality.${quality}`, { defaultValue: quality }) ?? t('ResultView.is_not_evaluated')}
          </Typography>
        }
        size='small'
        style={{
          zIndex: 2000,
          transform: zoomedProjection
            ? undefined
            : view_position === 'lcc' || view_position === 'lmlo'
            ? 'rotate(90deg)'
            : 'rotate(-90deg)',
          transformOrigin: 'center',
          background: `${qualityClassColor(qualityResult, theme)}50`,
          minWidth: '150px',
          cursor: qualityInRevison ? 'pointer' : 'help',
          borderRadius: '5px',
          height: '30px',
        }}
      />
    </Tooltip>
  );
};
